import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import GoalStaticsTotalDetailTable from '../../components/goal_statics/GoalStaticsTotalDetailTable';
import { getDeptList, getBudget } from '../../lib/api/establish';

const GoalStaticsTotalDetailContainer = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
  selectedLabel,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 통계 데이터 리스트
  const [deptList, setDeptList] = useState([]); // 부서 리스트
  const [budgets, setBudgets] = useState([]); // 예산(목표) 데이터 리스트

  // 데이터 로드 함수
  const onLoadData = useCallback(async () => {
    if (!selectedYear) return;

    setLoading(true);
    try {
      // 1. 부서, 통계, 예산 데이터를 병렬로 호출하여 속도 최적화
      const [deptRes, staticsRes, budgetRes] = await Promise.all([
        getDeptList(),
        staticsApi.getTotalExpectStatics(selectedYear, "01", "12"),
        getBudget(selectedYear)
      ]);

      // 2. 부서 리스트 저장
      const depts = deptRes.data?.list || [];
      setDeptList(depts);

      // 3. 통계 데이터 저장
      const staticsData = staticsRes.data?.list || [];
      setData(staticsData);

      // 4. 예산 데이터 저장
      const budgetData = budgetRes.data?.list || [];
      setBudgets(budgetData);

    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(`데이터를 불러오는 중 오류가 발생했습니다: ${message}`, { 
        variant: 'error' 
      });
    } finally {
      setLoading(false);
    }
  }, [selectedYear, enqueueSnackbar]);

  // 컴포넌트 마운트 및 연도 변경 시 호출
  useEffect(() => {
    onLoadData();
  }, [onLoadData]);

  return (
    <GoalStaticsTotalDetailTable
      selectedLabel={selectedLabel}
      data={data}        // 실제 실적 데이터
      budgets={budgets}  // 가져온 예산 데이터 전달
      deptList={deptList} // 부서 정보 전달
      loading={loading}
      tableRef={tableRef}
      selectedYear={selectedYear}
      strMonth={strMonth}
      endMonth={endMonth}
    />
  );
};

export default GoalStaticsTotalDetailContainer;
